import {NetworkTypes} from 'presentation/modules/guide/health/ui/pages/HealthGuide/types';
import {translations} from 'presentation/translations-new';

const {accreditedNetwork, selfNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;
const DESCRIPTIONS: Partial<Record<NetworkTypes, string>> = {
	[NetworkTypes.SELF_NETWORK]: selfNetwork.onlineScheduleDescription,
	[NetworkTypes.NOTRE_DAME_HAPVIDA]: selfNetwork.onlineScheduleConsultationDescription,
	[NetworkTypes.ACCREDITED_NETWORK]: accreditedNetwork.phoneScheduleDescription,
	[NetworkTypes.ACCREDITED_NOTRE_DAME]: accreditedNetwork.phoneScheduleDescriptionFallback,
};

export {DESCRIPTIONS};
